<header class="cc-header" *ngrxLet="headerData$ as headerData">
  <div class="cc-grid-container cc-relative">
    <div class="cc-row cc-flex-justify-between">
      <cc-brand-link [url]="headerData?.url" [claim]="headerData?.claim" />
      <cc-dealer-locator location="header" />
    </div>
  </div>
</header>
